import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Header from "./pages/Header";
import Footer from "./pages/Footer";
import WeldingMaterials from "./pages/products/weldingMaterials";
import GasCylinders from "./pages/products/gasCylinders";
import RopesClambs from "./pages/products/RopesClambs";
import ProtectiveEquipment from "./pages/products/ProtectiveEquipment";
import RoadSafety from "./pages/products/RoadSafety";
import HostingerExpiryModal from "./HostingerExpiryModal";

function App() {
  const [showBackToTop, setShowBackToTop] = useState(false);

  // Function to handle scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowBackToTop(true);
      } else {
        setShowBackToTop(false);
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Function to scroll back to top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Router>
      {/*<HostingerExpiryModal />*/}
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products/welding-materials" element={<WeldingMaterials />} />
        <Route path="/products/gas-cylinders" element={<GasCylinders />} />
        <Route path="/products/ropes-clamps" element={<RopesClambs />} />
        <Route path="/products/ppe" element={<ProtectiveEquipment />} />
        <Route path="/products/safety" element={<RoadSafety />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
      {/* Back to Top Button */}
      {showBackToTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 bg-yellow-500 text-white p-3 rounded-full shadow-md hover:bg-yellow-600 transition duration-200"
          title="Back to Top"
        >
          ↑
        </button>
      )}
    </Router>
  );
}

export default App;
